import gradients from './gradients';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { GradientName } from '~/interfaces/GradientName';
import colors from '~/styles/common/modules/colors.module.scss';

export type CircularProgressBarType = {
  width?: string;
  percentage: number;
  strokeWidth?: number;
  backgroundColor: 'white' | 'black' | string;
  gradientName?: GradientName;
  progressColor?: keyof typeof colors;
};

function GradientSVG({ idCSS, gradientName }: { idCSS: string; gradientName: GradientName }) {
  const gradientStops = (gradients as any)[gradientName] || gradients.dual1;

  return (
    <svg style={{ height: 0, display: 'block' }}>
      <defs>
        <linearGradient id={idCSS} gradientTransform="rotate(90)">
          {gradientStops.map((stop: { percent: string; color: string }, index: number) => (
            <stop key={stop.percent + stop.color + index} offset={stop.percent} stopColor={stop.color} />
          ))}
        </linearGradient>
      </defs>
    </svg>
  );
}

export default function CircularProgressBar({
  width = '48px',
  percentage = 100,
  strokeWidth = 6,
  backgroundColor = 'white',
  gradientName = 'dual1',
  progressColor,
}: CircularProgressBarType) {
  const idCSS = `circularProgressBar${gradientName}`;
  const strokeColor = progressColor ? colors[progressColor] : `url(#${idCSS})`;

  return (
    <div style={{ height: width, width }}>
      {!progressColor && <GradientSVG idCSS={idCSS!} gradientName={gradientName!} />}
      <CircularProgressbar
        strokeWidth={strokeWidth}
        value={percentage}
        styles={{
          path: {
            stroke: strokeColor,
            height: '100%',
            strokeLinecap: 'butt',
          },
          trail: {
            stroke: backgroundColor,
          },
        }}
      />
    </div>
  );
}
